import { render, staticRenderFns } from "./InvoiceArticleList.vue?vue&type=template&id=90c897ea&scoped=true&"
import script from "./InvoiceArticleList.vue?vue&type=script&lang=js&"
export * from "./InvoiceArticleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90c897ea",
  null
  
)

export default component.exports